import {PureComponent} from 'react';
import {Router, Switch, Route} from 'react-router-dom';

import {ROUTE_PATH} from 'constants/routes';
import {history} from 'context/history';
import {ClientConference, ClientJoinSessionPage, ClientConferenceWeb} from 'pages';
import {InviteeToken} from 'services';
import {InviteeParticipantRole} from 'types';

export const CLIENT_CONNECT_TOKEN_QUERY = 'cct';

export default class ClientApp extends PureComponent {
    state = {
        initialized: false
    };

    componentDidMount() {
        InviteeToken.init(InviteeParticipantRole.Client);
        const urlParams = new URLSearchParams(history.location.search);
        const cctToken = urlParams.get(CLIENT_CONNECT_TOKEN_QUERY);

        if (cctToken && (history.location.pathname === '/' || history.location.pathname === '')) {
            history.replace(`/client/connect?token=${cctToken}`);
        }

        this.setState({initialized: true});
    }

    render() {
        if (!this.state.initialized) {
            return null;
        }

        return (
            <Router history={history}>
                <Switch>
                    <Route path={ROUTE_PATH.CLIENT.CONFERENCE._SELF} component={ClientConference} />
                    <Route path={ROUTE_PATH.CLIENT.CONNECT} render={(props: any) => <ClientConferenceWeb {...props} isClientConnect />} />
                    <Route exact path={ROUTE_PATH.CLIENT.JOIN} component={ClientJoinSessionPage} />
                    <Route exact path={ROUTE_PATH.CLIENT.JOIN_WITH_CODE} component={ClientJoinSessionPage} />
                    {/* TODO: START_PAGE used in live help sdk.
                        Do we need an extra page for it with a logic or it's ok to just use ClientConferenceWeb? */}
                    <Route path={ROUTE_PATH.CLIENT.START_PAGE} component={ClientConferenceWeb} />
                </Switch>
            </Router>
        );
    }
}
